import { EventEmitter } from 'events';
import dispatcher from '../dispatcher';
import { Auth } from "aws-amplify";

class AuthStore extends EventEmitter {
	constructor() {
		super();
		this.authData = {
			isAuthenticated: false,
			isAuthenticating: true,
		}
		this.user = '';
	}

	getAuthenticationData() {
		return this.authData;
	}


	async getCurrentSession() {
		try {
			let currentSession = await Auth.currentSession();
			if(currentSession) {
				this.authData.isAuthenticated = true;
			}
		} catch(e) {
			this.authData.isAuthenticated = false;
		}
		this.authData.isAuthenticating = false;
	}
	
	async handleAction(action) {
		switch(action.type) {
			case 'get_current_session':
			await this.getCurrentSession();
			this.emit('change');
			break;
			case 'user_logged':
				this.authData.isAuthenticated = true;
				this.user = action.user;
				this.emit("change");
			break;
			case 'user_logout':
				Auth.signOut()
				.then((data) => {
					this.authData.isAuthenticated = false;
					this.emit('change');
				})
				.catch(err => console.error(err));
			break;
			default:
			break;
		}
	}
}

const store = new AuthStore();
dispatcher.register(store.handleAction.bind(store));
export default store


// WEBPACK FOOTER //
// ./src/stores/auth-store.js